import { Injectable } from "@angular/core";
import { Observable, Observer } from "rxjs";
declare var google;
/**
 * GeocodingService class.
 * https://developers.google.com/maps/documentation/javascript/
 */
@Injectable()
export class GeocodingService {
  // geocoder: google.maps.Geocoder;

  // constructor() {
  //   this.geocoder = new google.maps.Geocoder();
  // }

  // /**
  //  * Reverse geocoding by location.
  //  *
  //  * Wraps the Google Maps API geocoding service into an observable.
  //  *
  //  * @param request google.maps.GeocoderRequest
  //  * @return An observable of GeocoderResult
  //  */
  // geocode(
  //   request: google.maps.GeocoderRequest
  // ): Observable<google.maps.GeocoderResult[]> {
  //   return Observable.create(
  //     (observer: Observer<google.maps.GeocoderResult[]>) => {
  //       // Invokes geocode method of Google Maps API geocoding.
  //       this.geocoder.geocode(
  //         request,
  //         (
  //           results: google.maps.GeocoderResult[],
  //           status: google.maps.GeocoderStatus
  //         ) => {
  //           if (status === google.maps.GeocoderStatus.OK) {
  //             observer.next(results);
  //             observer.complete();
  //           } else {
  //             console.log(
  //               'Geocoding service: geocoder failed due to: ' + status
  //             );
  //             observer.error(status);
  //           }
  //         }
  //       );
  //     }
  //   );
  // }

  // /**
  //  * Geocoding service.
  //  *
  //  * Wraps the Google Maps API geocoding service into an observable.
  //  *
  //  * @param address The address to be searched
  //  * @return An observable of GeocoderResult
  //  */
  // codeAddress(address: string): Observable<google.maps.GeocoderResult[]> {
  //   return Observable.create(
  //     (observer: Observer<google.maps.GeocoderResult[]>) => {
  //       // Invokes geocode method of Google Maps API geocoding.
  //       this.geocoder.geocode(
  //         { address: address },
  //         (
  //           results: google.maps.GeocoderResult[],
  //           status: google.maps.GeocoderStatus
  //         ) => {
  //           if (status === google.maps.GeocoderStatus.OK) {
  //             observer.next(results);
  //             observer.complete();
  //           } else {
  //             console.log(
  //               'Geocoding service: geocode was not successful for the following reason: ' +
  //                 status
  //             );
  //             observer.error(status);
  //           }
  //         }
  //       );
  //     }
  //   );
  // }
}
